import { z } from "zod";
import { pageImageLinkSchema } from "@/features/salon";

/** A picture the salon uploaded, with the words it wrote for it (design note salon-home-landing.md 7b). */
const publicImageSchema = z.object({ url: pageImageLinkSchema, altText: z.string().default("") });

/**
 * A published article, as a list shows it (design note salon-home-landing.md 9.1; TDD-SA FR-SA-192).
 * A picture that fails its check is dropped rather than failing the article.
 */
export const articleSummarySchema = z.object({
  id: z.string(),
  title: z.string(),
  tag: z.string().nullable().default(null),
  summary: z.string().nullable().default(null),
  image: publicImageSchema.nullable().catch(null).default(null),
  publishedAt: z.string(),
});

/** The article itself: its body is plain text, split into paragraphs on blank lines. */
export const articleSchema = articleSummarySchema.extend({ body: z.string() });

export type ArticleSummary = z.infer<typeof articleSummarySchema>;
export type Article = z.infer<typeof articleSchema>;

/** The body's paragraphs: blank lines separate them, single line breaks stay inside one. */
export function paragraphsOf(body: string): string[] {
  return body
    .split(/\n\s*\n/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean);
}
